// src/pages/ResourcesPage.jsx
import { useEffect, useState } from "react";
import MastersCrudPage from "../components/MastersCrudPage";
import {
  listResources,
  createResource,
  updateResource,
  deleteResource,
  listLocations,
} from "../api/mastersApi";

export default function ResourcesPage() {
  const [locations, setLocations] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await listLocations();
        console.log(data);


        // Normalizar la respuesta: data puede ser un array, o un objeto con { data: [...] }, etc.
        if (Array.isArray(data)) {
          setLocations(data);
        } else if (data && Array.isArray(data.data)) {
          setLocations(data.data);
        } else if (data && Array.isArray(data.resources)) {
          // por si la API devuelve { resources: [...] }
          setLocations(data.resources);
        } else if (data && Array.isArray(data.locations)) {
          // por si la API devuelve { locations: [...] }
          setLocations(data.locations);
        } else {
          setLocations([]); // fallback seguro
        }

      } catch (err) {
        console.error("Error cargando locations", err);
        setLocations([]); // fallback seguro
      }
    })();
  }, []);

  return (
    <MastersCrudPage
      title="Resources"
      fetchList={listResources}
      createItem={createResource}
      updateItem={updateResource}
      deleteItem={deleteResource}
      columns={[
        { key: "id", label: "ID" },
        { key: "name", label: "Nombre" },
        { key: "resource_type", label: "Tipo" },
        { key: "location_id", label: "Location" },
        { key: "is_active", label: "Activo" },
      ]}
      initialForm={() => ({ name: "", resource_type: "generic", location_id: null, capacity: 1, is_active: 1 })}
      renderForm={({ form, setForm }) => (
        <>
          <div>
            <label className="block text-xs text-gray-400">Tipo</label>
            <input value={form.resource_type} onChange={e => setForm({...form, resource_type: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>
          <div>
            <label className="block text-xs text-gray-400">Nombre</label>
            <input value={form.name} onChange={e => setForm({...form, name: e.target.value})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
          </div>

          <div className="grid grid-cols-2 gap-2">
            <div>
              <label className="block text-xs text-gray-400">Location</label>
              <select value={form.location_id ?? ""} onChange={e=> setForm({...form, location_id: e.target.value ? Number(e.target.value) : null})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
                <option value="">-- sin ubicación --</option>
                {locations.map(l => <option key={l.id} value={l.id}>{l.name}</option>)}
              </select>
            </div>
            <div>
              <label className="block text-xs text-gray-400">Capacidad</label>
              <input type="number" value={form.capacity ?? ""} onChange={e=> setForm({...form, capacity: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700" />
            </div>
          </div>

          <div>
            <label className="block text-xs text-gray-400">Activo</label>
            <select value={form.is_active} onChange={e => setForm({...form, is_active: Number(e.target.value)})} className="w-full p-2 rounded bg-[#020817] border border-gray-700">
              <option value={1}>Sí</option>
              <option value={0}>No</option>
            </select>
          </div>
        </>
      )}
    />
  );
}
